import React, { useState } from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import { TextValidator, ValidatorForm, SelectValidator } from 'react-material-ui-form-validator';

const RoadsideAssistanceDetails = (props) => {
console.log("roadside assistance details props", props);
const classes = useStyle();
const [incidentDate, setIncidentDate] = useState(props.eventDate);
const [carRegistration, setCarRegistration] = useState(props.claimState.car_registration || '');
const [incidentLocation, setIncidentLocation] = useState(props.claimState.incident_location || '');
const [incidentTime, setIncidentTime] = useState(props.claimState.incident_time || '');
const [estimatedDistanceTowed, setEstimatedDistanceTowed] = useState(props.claimState.estimated_distance_towed || '');
const [assistanceType, setAssistanceType] = useState(props.claimState.assistance_type || []);
const [carryingStatus, setCarryingStatus] = useState(props.claimState.carrying_status || '');

const handleChange = (event) => {
  const { name, value } = event.target;
  
  switch (name) {
    case "incidentDate":
      setIncidentDate(value);
      props.setAdditionalState("incident_date", value);
      break;
    case "carRegistration":
      setCarRegistration(value);
      props.setAdditionalState("car_registration", value);
      break;
    case "incidentLocation":
      setIncidentLocation(value);
      props.setAdditionalState("incident_location", value);
      break;
    case "incidentTime":
      setIncidentTime(value);
      props.setAdditionalState("incident_time", value);
      break;
    case "estimatedDistanceTowed":
      setEstimatedDistanceTowed(value);
      props.setAdditionalState("estimated_distance_towed", value);
      break;
    case "assistanceType":
      setAssistanceType(value);
      props.setAdditionalState("assistance_type", value);
      // Clear estimated distance if Towing Services is not selected
      if (!value.includes("Towing Services")) {
        setEstimatedDistanceTowed('');
        props.setAdditionalState("estimated_distance_towed", '');
      }
      break;
    case "carryingStatus":
      setCarryingStatus(value);
      props.setAdditionalState("carrying_status", value);
      break;
    default:
      break;
  }
};

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <div className={classes.headingclaim}>
            <h4>Claim Information For Roadside Assistance</h4>
          </div>
        </Grid>
      </Grid>
      <ValidatorForm onSubmit={() => { }}>
        <Grid container spacing={2} className={classes.selectpolicyWrapper}>

          <Grid item xs={12} md={3} sm={3}>
            <TextValidator
              id="incidentDate"
              label="Incident Date"
              name='incidentDate'
              value={incidentDate}
              disabled={true}
              // onChange={handleChange}
              fullWidth
              type='date'
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              validators={['required']}
              errorMessages={['Please enter incident date']}
              style={{ width: "100%" }}
            />

            
          </Grid>

          <Grid item xs={12} md={3} sm={3}>
            <TextValidator
              id="carRegistration"
              label="Car Registration"
              name='carRegistration'
              value={carRegistration}
              onChange={handleChange}
              fullWidth
              variant="outlined"
              validators={['required']}
              errorMessages={['Please enter car registration']}
              style={{ width: "100%" }}
            />
          </Grid>

          <Grid item xs={12} md={3} sm={3}>
            <TextValidator
              id="incidentLocation"
              label="Location of Incident/Accident"
              name='incidentLocation'
              value={incidentLocation}
              onChange={handleChange}
              fullWidth
              variant="outlined"
              validators={['required']}
              errorMessages={['Please enter incident location']}
              style={{ width: "100%" }}
            />
          </Grid>

          <Grid item xs={12} md={3} sm={3}>
            <TextValidator
              id="incidentTime"
              label="Time of Incident"
              name='incidentTime'
              value={incidentTime}
              onChange={handleChange}
              fullWidth
              type='time'
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              validators={['required']}
              errorMessages={['Please enter incident time']}
              style={{ width: "100%" }}
            />
          </Grid>

          <Grid item xs={12} md={3} sm={3}>
            <FormControl 
              fullWidth 
              variant="outlined" 
              error={assistanceType.length === 0}
              style={{ width: "100%" }}
            >
              <InputLabel id="assistanceType-label">Type of Assistance Needed</InputLabel>
              <Select
                labelId="assistanceType-label"
                id="assistanceType"
                name="assistanceType"
                multiple
                value={assistanceType}
                onChange={handleChange}
                label="Type of Assistance Needed"
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} size="small" />
                    ))}
                  </Box>
                )}
              >
                <MenuItem   
                sx={{
               fontFamily: "Open Sans",
               fontStyle: "normal",
               fontWeight: 300,
               fontSize: "10px",
               lineHeight: "16px",
               letterSpacing: "0.005em",
               color: "#000000",
                }}value="Towing Services">Towing Services</MenuItem>
                <MenuItem   
                sx={{
               fontFamily: "Open Sans",
               fontStyle: "normal",
               fontWeight: 300,
               fontSize: "10px",
               lineHeight: "16px",
               letterSpacing: "0.005em",
               color: "#000000",
               }}value="Minor Mechanical Assistance">Minor Mechanical Assistance</MenuItem>
                <MenuItem   
                sx={{
               fontFamily: "Open Sans",
               fontStyle: "normal",
               fontWeight: 300,
               fontSize: "10px",
               lineHeight: "16px",
               letterSpacing: "0.005em",
               color: "#000000",
               }}value="Flat Tyre Assistance">Flat Tyre Assistance</MenuItem>
                <MenuItem   
                sx={{
               fontFamily: "Open Sans",
               fontStyle: "normal",
               fontWeight: 300,
               fontSize: "10px",
               lineHeight: "16px",
               letterSpacing: "0.005em",
               color: "#000000",
                 }}value="Out of Fuel Assistance">Out of Fuel Assistance</MenuItem>
                <MenuItem   
                sx={{
               fontFamily: "Open Sans",
               fontStyle: "normal",
               fontWeight: 300,
               fontSize: "10px",
               lineHeight: "16px",
               letterSpacing: "0.005em",
               color: "#000000",
               }}value="Accommodation & Transport">Accommodation & Transport</MenuItem>
              </Select>
              {assistanceType.length === 0 && (
                <FormHelperText>Please select at least one assistance type</FormHelperText>
              )}
            </FormControl>
          </Grid>
            
            <Grid item xs={12} md={3} sm={3}>
              <TextValidator
                id="estimatedDistanceTowed"
                label="Estimated Distance Towed (km)"
                name='estimatedDistanceTowed'
                value={estimatedDistanceTowed}
                onChange={handleChange}
                fullWidth
                type='number'
                variant="outlined"
                validators={['required', 'isNumber', 'minNumber:0']}
                errorMessages={['Please enter estimated distance', 'Must be a number', 'Distance must be greater than 0']}
                style={{ width: "100%" }}
              />
            </Grid>

            <Grid item xs={12} md={3} sm={3}>
              <SelectValidator
                labelId="carrying-status"
                id="carrying-status"
                value={carryingStatus}
                name="carryingStatus"
                type="text"
                label="Carrying Status"
                onChange={handleChange}
                variant="outlined"
                validators={['required']}
                errorMessages={['Please select carrying status']}
                style={{ width: "100%" }}
                sx={{
                  fontFamily: "Open Sans",
                  fontStyle: "normal",
                  fontWeight: 300,
                  fontSize: "12px",
                  lineHeight: "16px",
                  letterSpacing: "0.005em",
                  color: "#000000",
                }}
              >
                {["Carrying", "Not Carrying"].map((status, index) => (
                  <MenuItem
                    key={index}
                    sx={{
                      fontFamily: "Open Sans",
                      fontStyle: "normal",
                      fontWeight: 300,
                      fontSize: "12px",
                      lineHeight: "16px",
                      letterSpacing: "0.005em",
                      color: "#000000",
                    }}
                    value={status}
                  >
                    {status}
                  </MenuItem>
                ))}
              </SelectValidator>
            </Grid>

       
          
        </Grid>
      </ValidatorForm>
    </>
  )
}

export default RoadsideAssistanceDetails;
